export const CDN_BASE = 'https://cdn.smarty.co.uk/files'

export const CDN_PRIVACY_POLICY = `${CDN_BASE}/SMARTY-Online-Privacy-Policy.pdf`
export const CDN_TERMS_AND_CONDITIONS = `${CDN_BASE}/SMARTY-Terms-And-Conditions.pdf`
export const CDN_PRICE_GUIDE = `${CDN_BASE}/SMARTY-Price-Guide.pdf`
export const CDN_REFER_A_FRIEND_TERMS = `${CDN_BASE}/SMARTY-Refer-a-Friend.pdf`
export const CDN_REFER_A_FRIEND_TERMS_UPDATE = `${CDN_BASE}/SMARTY-Refer-a-Friend-T&C-Update.pdf`
export const CDN_COMPLAINTS_CODE = `${CDN_BASE}/SMARTY-Customer-Complaints-Code.pdf`
export const CDN_PROMO_15MTH_6GB = `${CDN_BASE}/smarty-promo-15Mth6GB6Nov22NBO.pdf`
export const CDN_PROMO_15MTH_6GB_UPSELL = `${CDN_BASE}/smarty-promo-15Mth6GB6Nov22NBOUpsell.pdf`
